import { ShopperAiFlagKey } from "@redotech/feature-flags-keys-shopper-ai/keys";

export interface ShopperAgentAccessTeam {
  featureFlags?: { [ShopperAiFlagKey.SHOPPER_AGENT]?: boolean };
  settings: { recover?: { enabled?: boolean } };
}

/**
 * Commerce Agent is visible to teams flagged in, and to every Recover team,
 * which builds on the same agent.
 */
export function shopperAgentEnabled(team: ShopperAgentAccessTeam): boolean {
  return (
    team.featureFlags?.[ShopperAiFlagKey.SHOPPER_AGENT] === true ||
    team.settings.recover?.enabled === true
  );
}
